import React from 'react';
import { Row, StyledContainer, StyledErrorTextContainer, StyledHeaderContainer } from './PlusWebsiteEditor.styles';
import { useForm } from './hooks/useForm';
import { HealtheraButton } from '../../healtheraComponents';
import { WebsiteSection } from './types/sections';
import { ApiReadyWebsiteConfiguration, WebsiteConfiguration } from './types/websiteConfiguration';
import { StyledErrorText } from './components/ImageUploader/ImageUploader.styles';
import PharmacyLayout from './sections/Layouts/PharmacyLayout';
import PrescriberLayout from './sections/Layouts/PrescriberLayout';
import { getValidationSchema } from './utils/validationSchema';
import { EditorLayout } from './types/editor';

type Props = {
  layout: EditorLayout;
  config: WebsiteConfiguration;
  availableSections: WebsiteSection[];
  isNewConfig: boolean;
  onSubmit: (values: ApiReadyWebsiteConfiguration) => Promise<void>;
  validationSchema: ReturnType<typeof getValidationSchema>;
  postalPharmaciesCount?: number;
  setNotification: (notification: string) => void;
};

const getButtonText = (isNewConfig: boolean, isSubmitting: boolean) => {
  if (isNewConfig) {
    if (isSubmitting) {
      return 'Creating...';
    }

    return 'Create Configuration';
  }

  if (isSubmitting) {
    return 'Saving...';
  }

  return 'Save Changes';
};

const PlusWebsiteEditor = ({
  config,
  isNewConfig,
  availableSections,
  postalPharmaciesCount,
  validationSchema,
  setNotification,
  layout,
  onSubmit,
}: Props) => {
  const form = useForm(config, onSubmit, validationSchema);

  return (
    <StyledContainer>
      <StyledHeaderContainer>
        <h2>Plus Website settings</h2>
        <Row>
          {form.hasVisibleErrors && (
            <StyledErrorTextContainer>
              <StyledErrorText>Some required fields are not filled</StyledErrorText>
            </StyledErrorTextContainer>
          )}
          <HealtheraButton disabled={form.isSubmitting || form.hasVisibleErrors} onClick={() => form.handleSubmit()}>
            {getButtonText(isNewConfig, form.isSubmitting)}
          </HealtheraButton>
        </Row>
      </StyledHeaderContainer>
      {layout === EditorLayout.PHARMACY ? (
        <PharmacyLayout
          setNotification={setNotification}
          form={form}
          availableSections={availableSections}
          postalPharmaciesCount={postalPharmaciesCount}
        />
      ) : (
        <PrescriberLayout form={form} />
      )}
    </StyledContainer>
  );
};

export default PlusWebsiteEditor;
